import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combine class names with Tailwind-aware deduping.
 * Standard shadcn pattern: clsx for conditional classes, twMerge to resolve
 * conflicts (e.g. `cn('px-4', condition && 'px-8')` returns just `px-8`).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
